import { render } from "./ModalUserInfo.vue?vue&type=template&id=4d6a242c"
import script from "./ModalUserInfo.vue?vue&type=script&lang=js"
export * from "./ModalUserInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__